import Vuewx from "qxjs/lib/modules/vuewx/install";
import { sdk } from "../../drivers/sdkDriver";

export default function(Vue) {
  Vue.use(Vuewx, {
    sdk,
  });
}
